























































































































































































































































































































































import {
  leaveList,
  leaveListData,
  leaveStatus,
  leavedetail,
  leavePass,
  leaveCancel,
} from "@/api/rollCallRecord";
import { dateFormat } from "@/utils/timeFormat";
import refuseDialog from "./refuseDialog.vue";
import { Component, Prop, Vue } from "vue-property-decorator";
import { PageModule } from "@/store/module/page";
@Component({
  components: {
    refuseDialog,
  },
})
//差老师和课程顾问接口列表
export default class extends Vue {
  searchInfo: any = {
    status: [1] as number[],
  }; //搜索数据
  tableData = []; //列表数据
  pageSize = 10;
  pageSizeArray = [10, 30, 50];
  total = 0;
  page = 1;
  processing = [];
  drawer = false;
  dialogForm = {};
  drawerDetails = {
    student_class_lesson: [],
    student: {},
  };
  leave_id = 0;
  imageDialogVisible: boolean = false;
  imageDialogSrc: string = "";
  created() {
    const _t = this as any;
    if (
      PageModule.latestRoute === "classTimeDetails" ||
      PageModule.latestRoute === "rollCallDetails" ||
      PageModule.latestRoute === "leaveAppliDetails"
    ) {
      // 内页返回
      const cache = PageModule.pageInfo.rollCallRecordList;
      if (cache.leaveAppLicationPage) {
        _t.page = cache.leaveAppLicationPage;
      } else {
        PageModule.SET_PAGE_INFO({
          name: "rollCallRecordList",
          key: "leaveAppLicationPage",
          value: _t.page,
        });
      }
    }
    _t.getList({
      page: _t.page,
      page_size: _t.pageSize,
    });
    _t.leaveStatusList();
  }
  resetSearch() {
    this.searchInfo = {
      status: [],
    };
    this.page = 1;
    this.pageSize = 10;
    this.getList({
      page: 1,
      page_size: 10,
    });
  }
  lookDetails(e: { id: number }) {
    const _t = this;
    _t.leave_id = e.id;
    leavedetail({ leave_id: e.id }).then((res: any) => {
      if (res.error_code == 0) {
        _t.drawer = true;
        switch (res.data.status) {
          case 1:
            res.data.statusName = "审批中";
            break;
          case 2:
            res.data.statusName = "已批准";
            break;
          case 3:
            res.data.statusName = "未批准";
            break;
          case 4:
            res.data.statusName = "撤销";
            break;
        }
        _t.drawerDetails = res.data;
      } else {
        _t.$message({
          type: "error",
          message: res.message,
        });
      }
    });
  }
  addStudents() {
    const _t = this;
    _t.$router.push({ name: "leaveAppliDetails" });
  }
  dateYearMonthDay(unixtime: number) {
    return dateFormat("YYYY-mm-dd HH:MM", new Date(Number(unixtime + "000")));
  }
  getList(data: leaveListData) {
    const _t = this as any;
    if (_t.searchInfo.key_word != "") {
      data.key_word = _t.searchInfo.key_word;
    }
    if (this.searchInfo.status.length != "") {
      data.status = this.searchInfo.status;
    }
    leaveList(data).then((res: any) => {
      if (res.error_code == 0) {
        if (res.data.list != null) {
          res.data.list.map((a: any) => {
            a.create_time = dateFormat(
              "YYYY-mm-dd HH:MM",
              new Date(Number(a.create_time + "000"))
            );
            const days = dateFormat(
              "YYYY-mm-dd",
              new Date(Number(a.start_time + "000"))
            );
            const endday = dateFormat(
              "YYYY-mm-dd",
              new Date(Number(a.end_time + "000"))
            );
            if (days == endday) {
              a.start_time = dateFormat(
                "YYYY-mm-dd HH:MM",
                new Date(Number(a.start_time + "000"))
              );
              a.end_time = dateFormat(
                "HH:MM",
                new Date(Number(a.end_time + "000"))
              );
            } else {
              a.start_time = dateFormat(
                "YYYY-mm-dd HH:MM",
                new Date(Number(a.start_time + "000"))
              );
              a.end_time = dateFormat(
                "YYYY-mm-dd HH:MM",
                new Date(Number(a.end_time + "000"))
              );
            }
            a.update_time = dateFormat(
              "YYYY-mm-dd HH:MM",
              new Date(Number(a.update_time + "000"))
            );
            switch (a.status) {
              case 1:
                a.statusName = "审批中";
                break;
              case 2:
                a.statusName = "已批准";
                break;
              case 3:
                a.statusName = "未批准";
                break;
              case 4:
                a.statusName = "撤销";
                break;
            }
          });
        }
        _t.tableData = res.data.list;
        _t.total = res.data.total;
        _t.page = res.data.page;
      } else {
        _t.$message({
          type: "error",
          message: res.message,
        });
      }
    });
  }
  leaveStatusList() {
    const _t = this;
    leaveStatus().then((res: any) => {
      if (res.error_code == 0) {
        _t.processing = res.data.list;
      } else {
        _t.$message({
          type: "error",
          message: res.message,
        });
      }
    });
  }
  handleSearch() {
    const _t = this as any;
    this.getList({
      page: 1,
      page_size: _t.pageSize,
    });
  }
  handleRefresh() {
    this.getList({
      page: this.page,
      page_size: this.pageSize,
    });
    this.drawer = false;
  }
  handlePagerChange(e: any) {
    PageModule.SET_PAGE_INFO({
      name: "rollCallRecordList",
      key: "leaveAppLicationPage",
      value: e,
    });
    this.getList({
      page: e,
      page_size: this.pageSize,
    });
  }
  handlePagerSizeChange(e: any) {
    this.pageSize = e;
    this.getList({
      page: 1,
      page_size: e,
    });
  }
  closeDrawer(type: string, lid: number, name: string) {
    const _t = this as any;
    if (type == "revoke") {
      _t.$confirm(
        "撤销后请假申请将失效，对应的签到及消课状态不会发生变化，需要手动调整课时签到状态，撤销后无法恢复。",
        `撤销 - ${name}请假`,
        {
          confirmButtonText: "确定",
          confirmButtonClass: "mwow-button-filled success mini",
          cancelButtonText: "取消",
          cancelButtonClass: "mwow-button-filled mini",
          type: "warning",
        }
      )
        .then(() => {
          leaveCancel({ leave_id: lid }).then((res: any) => {
            if (res.error_code == 0) {
              _t.$message({
                type: "success",
                message: "撤销成功",
              });
              _t.getList({
                page: _t.page,
                page_size: _t.pageSize,
              });
              _t.drawer = false;
            }
          });
        })
        .catch(() => {});
    } else if (type == "agree") {
      _t.$confirm(
        "同意后，会给学员与教师推送通知，学员在请假时间内的课时状态会自动变更，但依然允许在点名中修改。",
        `同意 - ${name}请假`,
        {
          confirmButtonText: "确定",
          confirmButtonClass: "mwow-button-filled success mini",
          cancelButtonText: "取消",
          cancelButtonClass: "mwow-button-filled mini",
          type: "warning",
        }
      )
        .then(() => {
          leavePass({ leave_id: lid }).then((res: any) => {
            if (res.error_code == 0) {
              _t.$message({
                type: "success",
                message: "同意成功",
              });
              _t.getList({
                page: _t.page,
                page_size: _t.pageSize,
              });
              _t.drawer = false;
            }
          });
        })
        .catch(() => {});
    }
  }
  showImageDialog(src: string) {
    this.imageDialogVisible = true;
    this.imageDialogSrc = src;
  }
  goDetail(status: number, lid: string, rowCallId: string) {
    // 课次详情
    if (status === 1) {
      this.$router.push({
        name: "classTimeDetails",
        query: {
          id: lid,
        },
      });
      // 点名详情
    } else if (status === 2) {
      this.$router.push({
        name: "rollCallDetails",
        query: {
          id: rowCallId,
        },
      });
    }
  }
}
